module.exports = __webpack_public_path__ + "static/media/LUX.e32e5a42.svg";